// @flow

import styled from "styled-components";

import * as colors from "src/styles/constants/colors";
import * as radius from "src/styles/constants/radius";

const PromptInput = styled.div`
  width: 100%;
  margin-top: 4px;
  border: 1px solid ${colors.grey35};
  border-radius: ${radius.medium};
`;

const FileInput = styled.input`
  display: none;
`;

const FileUploadContainer = styled.div`
  padding: 8px;
`;

const UploadedFiles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const FileItem = styled.div`
  border: 1px solid ${colors.grey35};
  border-radius: ${radius.small};
  padding: 4px 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;

const RemoveButton = styled.div`
  width: 16px;
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export {
  PromptInput,
  FileInput,
  FileUploadContainer,
  FileItem,
  RemoveButton,
  UploadedFiles,
};
